// SPDX-FileCopyrightText: 2022-2026 Lablup Inc. All rights reserved.
// SPDX-License-Identifier: LicenseRef-Proprietary
import type { JSX } from "react";
import { Navigate } from "react-router-dom";

import { useCurrentUser } from "../../hooks/useCurrentUser";
// Static (not lazy): already in the main chunk via App.tsx's static import, so
// React.lazy here would never fetch a chunk — it was dead indirection.
import FlexActivityIndicator from "../FlexActivityIndicator";

const RedirectIfAuth = ({ children }: { children: JSX.Element }) => {
  const { data: user, isLoading } = useCurrentUser();

  if (isLoading) {
    return <FlexActivityIndicator style={{ height: "100vh" }} size={48} />;
  }

  // Only a confirmed authenticated user should be bounced to /. When `user`
  // is null — whether due to no credentials or a transient backend failure —
  // keep rendering the login page so the user can retry without being
  // bounced somewhere unexpected. `CurrentUserErrorToaster` surfaces a single
  // toast for the underlying error. See issue #3382.
  return user ? <Navigate to="/" replace /> : children;
};

export default RedirectIfAuth;
